import { ReactElement } from 'react';
import { Alert, ALERT_STYLE_TYPE } from 'b2b-components/theme/components/Alert';
import { Props } from './';
import './Remark.scss';

export const Remark = ({ content }: Props): ReactElement => (
  <div className='ProductDescription-Remark'>
    <Alert styleType={ALERT_STYLE_TYPE.info}>
      <span
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
    </Alert>
  </div>
);
